import { StoreAppInfo } from "./types";

type ItunesLookupResponse = {
  resultCount: number;
  results: Array<{
    trackName?: string;
    version?: string;
    artworkUrl100?: string;
    trackViewUrl?: string;
    currentVersionReleaseDate?: string;
    averageUserRating?: number;
    userRatingCount?: number;
  }>;
};

export async function fetchIosAppInfo(bundleId: string): Promise<StoreAppInfo> {
  try {
    const response = await fetch(
      `https://itunes.apple.com/lookup?bundleId=${encodeURIComponent(
        bundleId,
      )}&country=nl`,
    );

    if (!response.ok) {
      throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    const data = (await response.json()) as ItunesLookupResponse;
    const app = data.results?.[0];

    if (!app) {
      return {
        platform: "ios",
        status: "offline",
        error: "Not found on App Store",
      };
    }

    return {
      platform: "ios",
      status: "online",
      name: app.trackName,
      version: app.version,
      iconUrl: app.artworkUrl100,
      storeUrl: app.trackViewUrl,
      lastUpdated: app.currentVersionReleaseDate || undefined,
      rating:
        typeof app.averageUserRating === "number" && app.userRatingCount
          ? `${app.averageUserRating.toFixed(1)} (${app.userRatingCount})`
          : undefined,
    };
  } catch (error) {
    return {
      platform: "ios",
      status: "offline",
      error: error instanceof Error ? error.message : "Lookup failed",
    };
  }
}
